import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { createSubjectReconciliationMatch, CreateSubjectReconciliationMatchPayload } from '../query-api'

interface UseCreateSubjectReconciliationSuggestionProps {
  onError?: (error?: APIError, variables?: CreateSubjectReconciliationMatchPayload) => void
  onSuccess?: () => void
}

export const useCreateSubjectReconciliationSuggestion = (props?: UseCreateSubjectReconciliationSuggestionProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: create,
    mutateAsync: createAsync,
    isLoading: isProcessing,
    ...rest
  } = useMutation(createSubjectReconciliationMatch, {
    onSuccess,
    onError,
  })

  return { create, createAsync, isProcessing, ...rest }
}
